import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private cardFiltersSubject = new BehaviorSubject<Record<string, any>>({});
  cardFilters$ = this.cardFiltersSubject.asObservable();

  private selectSpecialOffersFiltersSubject = new BehaviorSubject<
    Record<string, any>
  >({});
  selectSpecialOfferFilters$ =
    this.selectSpecialOffersFiltersSubject.asObservable();

  constructor() {}

  getCardFilters(): Record<string, any> {
    return this.cardFiltersSubject.value;
  }

  setCardFilters(fields: Record<string, any>): void {
    this.cardFiltersSubject.next(fields);
  }

  getSelectSpecialOffersFilters(): Record<string, any> {
    return this.selectSpecialOffersFiltersSubject.value;
  }

  setSelectSpecialOffersFilters(fields: Record<string, any>): void {
    this.selectSpecialOffersFiltersSubject.next(fields);
  }
}
